<template>
  <j-modal
    class="custom-modal"
    :title="title"
    :width="modelStyle.width"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :mask="false"
    :maskClosable="false"
    :dialogStyle="dialogStyle"
    :footer="null"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel">关闭</a-button>
      <a-button v-if="record.openType==='url'" type="primary" @click="toHandle">去处理</a-button>
    </template>
    <a-card class="daily-article" :loading="loading">
      <!-- 显示投保人信息 -->
      <a-card-meta
        :title="record.titile"
        :description="' 发布时间：' + record.sendTime"
        style="padding: 0;"
      ></a-card-meta>
      <a-divider />

      <!-- 渲染其他信息 -->
      <div class="message-container">
        <div v-html="processedContent.otherContent"></div>
      </div>

      <!-- 渲染险种列表 -->
      <div
        v-for="(performance, index) in processedContent.insuranceList"
        :key="index"
        class="insurance-item"
        style="margin-bottom: 12px;"
      >
        <p style="margin: 0;">险种: {{ performance.insuranceType }}</p>
        <a-collapse ghost>
          <a-collapse-panel
            :header="`业绩编号列表（共 ${performance.performanceList.length} 条）`"
            :key="index"
            style="padding: 0;"
          >
            <ul style="list-style: none; padding: 0; margin: 0;">
              <li
                v-for="(item, idx) in performance.performanceList"
                :key="idx"
                style="font-size: 14px; margin: 4px 0;"
              >
                业绩编号: {{ item['业绩编号'] }}，剩余天数: {{ item['剩余天数'] }}
              </li>
            </ul>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </a-card>
  </j-modal>
</template>

<script>
import { Collapse } from 'ant-design-vue'
import 'ant-design-vue/es/collapse/style/css'; // 引入样式
export default {
  name: "SysAnnouncementModal",
  components: {
    'a-collapse': Collapse,
    'a-collapse-panel': Collapse.Panel,
  },
  data () {
    return {
      title:"通知消息",
      record: {},
      callback: null,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      visible: false,
      switchFullscreen: true,
      loading: false,
      bodyStyle:{
        padding: "0",
        height:(window.innerHeight*0.2)+"px",
        "overflow-y":"auto",

      },
      modelStyle:{
        width: '20%',
        fullScreen: false
      },
      dialogStyle:{
        left: '28%',
        top: '57%',
        // left: '1%',
        // top: '10%',
      }
    }
  },
  created () {
  },
  methods: {
    detail (record,callback) {
      this.visible = true;
      this.record = record;
      this.callback = callback;
    },
    handleCancel () {
      this.visible = false;
      if(this.callback){
        this.callback(this.record);
      }
    },
    /** 切换全屏显示 */
    handleClickToggleFullScreen() {
      let mode = !this.modelStyle.fullScreen
      if (mode) {
        this.modelStyle.width = '100%'
        this.modelStyle.style.top = '20px'
      } else {
        this.modelStyle.width = '60%'
        this.modelStyle.style.top = '50px'
      }
      this.modelStyle.fullScreen = mode
    },
    toHandle(){
      if(this.record.openType==='url'){
        this.visible = false;
        //链接跳转
        this.$router.push({path: this.record.openPage})
      }
    },
  },

  computed: {
    processedContent() {
      const msg = (this.record && this.record.msgContent) ? this.record.msgContent : "";
      console.log("原始内容:", msg);

      if (!msg) {
        console.error("msgContent 为空或未定义");
        return {
          otherContent: "消息内容为空",
          insuranceList: [],
        };
      }

      // 检测是否为结构化 JSON 格式
      let parsedContent = [];
      try {
        parsedContent = JSON.parse(msg); // 尝试解析为 JSON
      } catch (error) {
        console.error("消息内容不是合法的 JSON:", error);
        return {
          otherContent: "解析错误，请检查数据格式",
          insuranceList: [],
        };
      }

      // 提取 `createBy` 和 `insurer` 信息
      const otherContent = {
        // 负责人: parsedContent[0] && parsedContent[0].createBy ? parsedContent[0].createBy : "未知",
        负责人: this.$store.getters.nickname || "未知",
        投保人: parsedContent[0] && parsedContent[0].insurer ? parsedContent[0].insurer : "未知"
      };

      // 提取 `projectList` 和其中的 `insuranceTypeList`
      var insuranceList = (parsedContent[0] && parsedContent[0].projectList || []).reduce(function (acc, project) {
        return acc.concat((project.insuranceTypeList || []).map(function (type) {
          return { // 修复点：加上 return 和 {}
            insuranceType: type.insuranceType,
            performanceList: type.performanceList.map((performance) => ({
              业绩编号: performance.performanceId,
              剩余天数: performance.remainingDays,
            })),
          };
        }));
      }, []);

      console.log("解析结果:", { otherContent, insuranceList });

      return {
        otherContent: Object.entries(otherContent)
          .map(([key, value]) => `${key}: ${value}`)
          .join("<br>"),
        insuranceList,
      };
    },
  }


}
</script>

<style lang="less">
/*.announcementCustomModal{
  .ant-modal-header {
    border: none;
    display: inline-block;
    position: absolute;
    z-index: 1;
    right: 56px;
    padding: 0;
    .ant-modal-title{
      .custom-btn{
        width: 56px;
        height: 30px;
        border: none;
        box-shadow: none;
      }
    }
  }
  .daily-article{
    border-bottom: 0;
  }
}*/
/* 限制样式只在当前组件内的 custom-modal 上生效 */
.custom-modal .ant-modal-wrap {
  pointer-events: none !important;
}

.custom-modal .ant-modal {
  pointer-events: auto !important;
}
.custom-modal .ant-divider {
  margin: 0 !important;
  line-height: 0 !important;
  height: 0 !important; /* 确保分隔线高度为0 */
}
.custom-modal .ant-modal-footer {
  border-top: none !important; /* 移除顶部边框 */
}
</style>
<style scoped lang="less">
.daily-article {
  .article-button {
    font-size: 1.2rem !important;
  }
  .ant-card-body {
    padding: 18px !important;
  }
  .ant-card-head {
    padding: 0 1rem;
  }
  .ant-card-meta {
    margin-bottom: 1rem;
  }
  .article-content {
    p {
      word-wrap: break-word;
      word-break: break-all;
      text-overflow: initial;
      white-space: normal;
      font-size: .9rem !important;
      margin-bottom: .8rem;
    }
  }
}
.daily-article {
  border: none !important; /* 移除卡片边框 */
}

.daily-article .ant-card-body {
  padding: 0 !important; /* 移除内容内边距 */
}
.daily-article .ant-card-head {
  margin-bottom: 0 !important; /* 移除标题下方的间距 */
  border-bottom: none !important; /* 移除标题下方的边框 */
}
/*.custom-modal {
  /deep/ .ant-modal {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.8); !* 修改阴影颜色和深度 *!
  }
}*/
</style>
